import { connect } from 'react-redux';
import ProjectAddress from './ProjectAddress';

import { setProjectIsOpen } from './actions';
import {
    setProjectState,
    setProjectName,
    setProjectStreet,
    setProjectZip,
    setProjectCity,
    setProjectCountry,
    setProjectStreet2,
} from '../../common/projectaddress/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isOpen: state.projectaddressUI.isOpen,
    projectState: state.projectaddress.projectState,
    projectName: state.projectaddress.projectName,
    projectStreet: state.projectaddress.projectStreet,
    projectStreet2: state.projectaddress.projectStreet2,
    projectZip: state.projectaddress.projectZip,
    projectCity: state.projectaddress.projectCity,
    projectCountry: state.projectaddress.projectCountry,
    selectedState: state.clientInfoUI.selectedState,
    setProjectIsOpen,
    setProjectState,
    setProjectName,
    setProjectStreet,
    setProjectZip,
    setProjectCity,
    setProjectCountry,
    setProjectStreet2,
});

const combinedActions = {
    setProjectIsOpen,
    setProjectState,
    setProjectName,
    setProjectStreet,
    setProjectZip,
    setProjectCity,
    setProjectCountry,
    setProjectStreet2,
};

export default connect(mapStateToProps, combinedActions)(ProjectAddress);



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectAddress/index.js